import { render, staticRenderFns } from "./TestVideoListModal.vue?vue&type=template&id=395d4aa8"
import script from "./TestVideoListModal.vue?vue&type=script&lang=js"
export * from "./TestVideoListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports